<div class="toolbar">
  <span>
    <button matButton="text" (click)="goBack()">
      <span>
        <mat-icon>keyboard_arrow_left</mat-icon>
        <label>Back</label>
      </span>
    </button>
  </span>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  <mat-tab-group class="tab-group" [animationDuration]="50" [mat-stretch-tabs]="false">
    <mat-tab [labelClass]="'tab-label'" label="Performance Defaults">
      <app-entity-performance-defaults [entityId]="entityKey().entityId" [revision]="entityKey().entityRevision"
        (errorEvent)="handleError($event)">
      </app-entity-performance-defaults>
    </mat-tab>
    <mat-tab [labelClass]="'tab-label'" label="Riser Defaults">
      <app-riser-project-defaults [entityKey]="entityKey()" (errorEvent)="handleError($event)">
      </app-riser-project-defaults>
    </mat-tab>
  </mat-tab-group>
</div>
